import React from 'react';
import { Helmet } from 'react-helmet';
import { usePageData } from '../hooks/usePageData';
import { useGetExperiment } from '../hooks/useDataHooks';
import { jsx as _jsx } from "react/jsx-runtime";
function ABExperimentSnippet(_ref) {
  let {
    experimentSnippetName
  } = _ref;
  const {
    data: experiment
  } = useGetExperiment(experimentSnippetName);
  const {
    abTestingEnabled
  } = usePageData();
  return experiment && abTestingEnabled ? /*#__PURE__*/_jsx(Helmet, {
    children: /*#__PURE__*/_jsx("script", {
      "data-abexperiment": true,
      children: experiment
    })
  }) : null;
}

/**
 * @deprecated This component renamed as ABExperimentSnippet, please use that one instead.
 */
const BookingABExperiment = ABExperimentSnippet;
export { ABExperimentSnippet, BookingABExperiment };